import React from 'react'
import connect from "react-redux/es/connect/connect";
import _ from "underscore";
import ReactTimeAgo from 'react-time-ago';

import {showAlertMessage} from "../../../modules/alert";
import {showToastMessage} from "../../../modules/toast";
import {hideLoaderMessage, showLoaderMessage} from "../../../modules/loader";
import {DISTRICT_CODE, COPY_TO_CLIPBOARD, NAVER_THUMBNAIL_GETTER, SCHEDULE_SORT_KEY_TO_NAME} from "../../../modules/variable/common_variable";
import TargetNaverPlaceActionSheet from "./targetNaverPlaceActionSheet";
import TargetScheduleActionSheetComments from "./targetScheduleActionSheetComments";
import UserInfoDialog from '../../user/userInfoDialog';

class TargetScheduleActionSheetDescription extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            targetNaverPlaceActionSheet: {targetMarker: null, open: false},
            userInfoDialog: {open: false, uid: ''},
        }
    }

    componentDidMount(){

    }

    showTargetNaverPlaceActionSheet = (marker) => {
        this.setState({targetNaverPlaceActionSheet: {targetMarker: marker, open: true}});
    };

    showUserInfoDialog = (event, uid) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({userInfoDialog: {...this.state.userInfoDialog, open: true, uid: uid}});
    };

    render() {
        const { TSAS } = this.props;
        //console.log(this.state.targetScheduleActionSheet.targetNaverPlaceActionSheet);

        return (
            <div>
                <ul className="list--material list target-schedule-description">
                    <li className="list-header list-header--material">
                        지역
                    </li>
                    <li className="list-item list-item--material">
                        <div className="list-item__center list-item--material__center" style={{minHeight: 'auto', paddingTop: 0}}>
                            <div className="list-item__title list-item--material__title">{_.findWhere(DISTRICT_CODE, {code: TSAS.data.representative.district.code}).parent} {TSAS.data.representative.district.name}</div>
                        </div>
                    </li>
                    <li className="list-header list-header--material">
                        설명
                    </li>
                    <li className="list-item list-item--material">
                        <ul className="list list--material">
                            <li className="list-item list-item--material" style={{padding: 0}}>
                                {
                                    TSAS.data.description !== '' ?
                                        <div className="list-item__center list-item--material__center">
                                            <div className="list-item__title list-item__textarea">
                                                {TSAS.data.description}
                                            </div>
                                        </div>
                                        :
                                        <div className="list-item__center list-item--material__center">
                                            <div className="list-item__title text-center">
                                                <small>작성된 설명이 없습니다.</small>
                                            </div>
                                        </div>
                                }
                            </li>

                            {
                                TSAS.data.scheduleOrder.map((key, i) => {
                                    const e = TSAS.data.schedule[key];
                                    return (
                                        <li key={['list', 'in', 'description', key, i].join('_')} className="list-item list-item--material schedule-description-element">
                                            <ul className="list list--material">
                                                <li className="list-item list-item--material">
                                                    <div className="list-item__left list-item--material__left" onClick={() => this.showTargetNaverPlaceActionSheet(e)}>
                                                        <img className="list-item__thumbnail"
                                                             src={NAVER_THUMBNAIL_GETTER(e)}
                                                             onError={(e) => {
                                                                 e.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                             }} alt={e.name}/>
                                                    </div>
                                                    <div className="list-item__center list-item--material__center" onClick={() => this.showTargetNaverPlaceActionSheet(e)}>
                                                        <div className="list-item__title list-item--material__title">{i + 1}. {e.name}</div>
                                                        <div className="list-item__subtitle list-item--material__subtitle"/>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right">
                                                        <span className={['notification', 'notification--material', 'notification-category'].join(' ')}>{e.category ? e.category.split(',').join(', '): '없음'}</span>
                                                        {/*<span className={['notification', 'notification--material', 'notification-' + e.type].join(' ')}>{e.type === 'playing' ? '놀곳' : e.type === 'eating' ? '먹을곳' : '잘곳'}</span>*/}
                                                    </div>
                                                </li>
                                                {
                                                    e.userComment ?
                                                        <li className="list-item list-item--material">
                                                            <div className="list-item__center" style={{padding: '0 0 8px 0', minHeight: 'auto'}}>
                                                                <div className="list-item__title list-item--material__title list-item__textarea">{e.userComment}</div>
                                                            </div>
                                                        </li>
                                                        :
                                                        null
                                                }
                                            </ul>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </li>
                    <li className="list-header list-header--material">
                        태그
                    </li>
                    <li className="list-item list-item--material">
                        <div className="list-item__center list-item--material__center">
                        {
                            TSAS.data.searchTags.map((tag, i) => {
                              return (
                                  <span className="notification notification--material" key={['tag', i].join('_')}>{'#' + tag}</span>
                              )
                            })
                        }
                        </div>
                    </li>
                    {
                        TSAS.data.sort ?
                            <li className="list-header list-header--material">
                                유형
                            </li>
                            :
                            null
                    }
                    {
                        TSAS.data.sort ?
                            <li className="list-item list-item--material">
                                <div className="list-item__center list-item--material__center">
                                    {
                                        TSAS.data.sort ?
                                            Object.keys(TSAS.data.sort).map((key, i) => {
                                                if(TSAS.data.sort[key] === true){
                                                    return (
                                                        <span className="notification notification--material" key={['sort', i].join('_')} style={{backgroundColor: '#a0005e'}}>{SCHEDULE_SORT_KEY_TO_NAME[key]}</span>
                                                    )
                                                }
                                            })
                                            :
                                            null
                                    }
                                </div>
                            </li>
                            :
                            null
                    }
                </ul>

                {
                    TSAS.tab === 'description' ?
                        <TargetScheduleActionSheetComments DOC_ID={TSAS.data.DOC_ID}/>
                        :
                        <div/>
                }

                <li className="list-header list-header--material">
                    정보
                </li>
                <li className="list-item list-item--material">
                    <div className="list-item__center list-item--material__center" style={{minHeight: 'auto', paddingTop: 0}}>
                        <div className="list-item__subtitle list-item--material__subtitle" onClick={(event) => this.showUserInfoDialog(event, TSAS.data.uid)}>작성자: <strong id="information-link-id" >{TSAS.data.nickname}</strong></div>
                        <div className="list-item__subtitle list-item--material__subtitle">작성일: <strong id="information-link-id" ><ReactTimeAgo locale="ko">{TSAS.data.date}</ReactTimeAgo></strong></div>
                        <div className="list-item__subtitle list-item--material__subtitle" onClick={() => COPY_TO_CLIPBOARD('information-link-id', '아이디', this.props)}>ID: <strong id="information-link-id" >{TSAS.data.DOC_ID}</strong></div>
                        <div className="list-item__subtitle list-item--material__subtitle" onClick={() => COPY_TO_CLIPBOARD('information-link-url', '링크 URL', this.props)}>링크: <strong id="information-link-url">{window.location.origin + '/schedule?docId=' + TSAS.data.DOC_ID}</strong></div>
                    </div>
                </li>

                {
                    this.state.targetNaverPlaceActionSheet && this.state.targetNaverPlaceActionSheet.open ?
                        <TargetNaverPlaceActionSheet targetNaverPlaceActionSheet={this.state.targetNaverPlaceActionSheet} hideTNPAS={() => this.setState({targetNaverPlaceActionSheet : {...this.state.targetNaverPlaceActionSheet, open: false}})} />
                        :
                        null
                }

                {
                    this.state.userInfoDialog.open ?
                        <UserInfoDialog open={true} uid={this.state.userInfoDialog.uid} hide={() => this.setState({userInfoDialog: {...this.state.userInfoDialog, open: false}})}/>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showLoaderMessage: message => dispatch(showLoaderMessage(message)),
    hideLoaderMessage: () => dispatch(hideLoaderMessage()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TargetScheduleActionSheetDescription)
